(function($) {
  
  //slideshow style interval
  // var autoSwap = setInterval(swap, 5000);
  
  //pause slideshow and reinstantiate on mouseout
  $('ul, span').hover(
    function() {
      // clearInterval(autoSwap);
    },
    function() {
      // autoSwap = setInterval(swap, 5000);
    });
  
  //global variables
  var items = [];
  var startItem = 1;
  var position = 0;
  var itemCount = $('.carousel li.items').length;
  var leftpos = itemCount;
  var resetCount = itemCount;
  
  //unused: gather text inside items class
  $('li.items').each(function(index) {
    items[index] = $(this).attr('id');
  });
  
  //swap images function
  function swap(action) {
    var direction = action;
    var main;
    var left;
    var right;

    //moving carousel backwards
    if (direction == 'counter-clockwise') {
      main = $('.main-pos').attr('id');
      left = $('.left-pos').attr('id');
      right = $('.right-pos').attr('id');
  
      $('#'+main).removeClass('main-pos').addClass('right-pos');
      $('#'+left).removeClass('left-pos').addClass('main-pos');
      $('#'+right).removeClass('right-pos').addClass('left-pos');
    }
  
    //moving carousel forward
    if (direction == 'clockwise' || direction == '' || direction == null) {
      
      function pos(positionvalue) {
        if (positionvalue != 'leftposition') {
          //increment image list id
          position++;
  
          //if final result is greater than image count, reset position.
          if ((startItem + position) > resetCount) {
            position = 1 - startItem;
          }
        }
  
        //setting the left positioned item
        if (positionvalue == 'leftposition') {
          //left positioned image should always be one left than main positioned image.
          position = startItem - 1;
  
          //reset last image in list to left position if first image is in main position
          if (position < 1) {
            position = itemCount;
          }
        }
  
        return position;
      }
      
      main = $('.main-pos').attr('id');
      left = $('.left-pos').attr('id');
      right = $('.right-pos').attr('id');
  
      $('#'+main).removeClass('main-pos').addClass('left-pos');
      $('#'+left).removeClass('left-pos').addClass('right-pos');
      $('#'+right).removeClass('right-pos').addClass('main-pos');
    }
    
  }
  
  //if any visible items are clicked
  $('li').click(function() {
    if ($(this).attr('class') == 'items left-pos') {
      swap('counter-clockwise');
    } else {
      swap('clockwise');
    }
  });
    
})(jQuery); // Fully reference jQuery after this point.